/**
 * Saneamento de theme-id (D12, onda 3). O enum numérico antigo (ThemeType) foi deletado —
 * o tema é identificado só pelo id kebab-case (string), casando com a tabela `theme` e com o
 * nome do {id}.json no Static. A lista de temas ativos vem de GET /api/themes.
 */

/**
 * Normaliza um theme id vindo de fora (localStorage/JWT antigo) para o id canônico
 * (minúsculo, igual ao nome do arquivo em themes/templates/). Um id desconhecido passa
 * adiante sem alteração — templateLoader.loadTemplate já cai no default (piso) se o
 * {id}.json não existir no Static (D13).
 * @param {string} themeId
 * @returns {string}
 */
export function normalizeThemeId(themeId) {
  if (!themeId) return 'default';
  if (themeId === 'COMPANY') return 'company';   // legado pré-fix (2026-07-10)
  return themeId;
}
